import { roundSectionLayer } from '@components/map/layers/round/roundSection.layer';
import { useMapContext } from '@components/map/MapContext';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectRoundSectionsFeatures } from '@redux/config/config.selectors';
import { Layer, Source } from 'react-map-gl/mapbox';

import { SourceNameEnum } from '@/types/map.types';

export default function RoundLayer() {
  const { viewState } = useMapContext();
  const segmentFeatures = useSelectorWithReplayMode(selectRoundSectionsFeatures, viewState.zoom);

  return (
    <Source id={SourceNameEnum.ROUNDS} type="geojson" data={segmentFeatures}>
      <Layer {...roundSectionLayer} />
    </Source>
  );
}
